/* eslint-disable no-constant-condition */
import React from "react"
import intl from "react-intl-universal"
import styles from "./index.module.scss"
import { IMPRECISION_TYPES } from "../../../../constants"

const MaxImprecision = (props) => {
  const { oAnalyte } = props

  const bHasMaxImprecision = oAnalyte?.eqpanlt_bmax_imprecision
  if (!bHasMaxImprecision) return null

  const cImprecisionType = oAnalyte?.eqpanlt_eimprecision_type

  return (
    <div className={styles.maxImprecisionContainer}>
      {cImprecisionType === IMPRECISION_TYPES.MANUAL && <Manual oAnalyte={oAnalyte} />}
      {cImprecisionType === IMPRECISION_TYPES.BIOLOGICAL_VARIATION && (
        <BiologicalVarition biologicalVariation={oAnalyte?.biological_variation} />
      )}
    </div>
  )
}

export default MaxImprecision

const Manual = ({ oAnalyte }) => (
  <>
    <p className={styles.maxImprecision}>
      {intl.get("ciq.release_details.max_imprecision.title")}{" "}
      {`${Number(oAnalyte?.eqpanlt_nimprecision_value).toLocaleString()}%`}
    </p>
    {oAnalyte?.eqpanlt_cjustification && (
      <p className={styles.justification}>
        <span>{intl.get("ciq.release_details.max_imprecision.justification")} </span>
        {oAnalyte?.eqpanlt_cjustification}
      </p>
    )}
  </>
)

const BiologicalVarition = ({ biologicalVariation }) => biologicalVariation && (
  <>
    <p className={styles.maxImprecision}>
      {intl.get("ciq.release_details.max_imprecision.title")}{" "}
      {biologicalVariation?.biovar_analyte} -{" "}
      {`${Number(biologicalVariation?.biovar_te).toLocaleString()}%`} -{" "}
      {biologicalVariation?.biovar_type}
    </p>

    <p className={styles.justification}>
      <span>{intl.get("ciq.release_details.max_imprecision.justification")} </span>
      {intl.get("ciq.release_details.max_imprecision.biological_variation.justification")}
      <br />
      {intl.get("ciq.release_details.max_imprecision.biological_variation.source")}{" "}
      <a
        href="https://www.westgard.com/clia-a-quality/quality-requirements/238-biodatabase1.html"
        rel="noreferrer"
        target="_blank"
      >
        Desirable Biological Variation Database specifications - Westgard
      </a>
    </p>
  </>
)
